import React from "react";
import { WithAPICall } from "../utils/apiUtil";
import {
  Alert,
  Card,
  LinearProgress,
  Paper,
  Button,
  Typography,
  TextField,
  IconButton,
} from "@mui/material";
import { View500 } from "src/sections/error";
import { Box, Stack } from "@mui/system";
import Markdowner from "./Markdowner";
import cogoToast from "cogo-toast";
import Iconify from "src/components/iconify";
import { LoadingButton } from "@mui/lab";
import { copyToClipboard } from "../utils/fn";
import AsstMessage from "./AsstMessage";

class Thread extends React.Component {
  state = {
    isLoading: true,
    isError: false,
    messages: [],
  };
  componentDidMount() {
    this.getThreadById();
  }

  getThreadById = async () => {
    const { id } = this.props;
    try {
      const response = await this.props.apiCallPostUnAuth(
        `/harley/getPublicThreadById`,
        {
          threadId: id,
        }
      );
      this.setState({
        isLoading: false,
        ...response,
      });
    } catch (error) {
      cogoToast.error("Error fetching thread");
      this.setState({ isLoading: false, isError: true });
    }
  };
  registerInterest = async () => {
    try {
      this.setState({
        isRegistering: true,
      });
      const response = await this.props.apiCallPostUnAuth(
        `/harley/registerInterest`,
        {
          publicThreadId: this.props.id,
          email: this.state.email,
        }
      );
      this.setState({
        isRegistering: false,
      });

      cogoToast.success("Interest registered");
    } catch (error) {
      this.setState({
        isRegistering: false,
      });
      cogoToast.error("Error registering interest");
    }
  };
  renderMessages = () => {
    if (!this.state.messages.length) {
      return (
        <div
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Alert severity="info">
            No messages yet. Get started by typing or speaking below.
          </Alert>
        </div>
      );
    }
    return (
      <Stack spacing={2}>
        {this.state.messages.map((x) => {
          let role = x.role;
          let content = x.content;
          if (role === "user") {
            return (
              <Card
                sx={{
                  p: 1,
                  m: 1,
                  bgcolor: "background.neutral",
                  borderRadius: 2,
                  boxShadow: 3,
                }}
              >
                <Stack>
                  <Typography variant="overline">
                    {this.state.userId?.name || "User"}
                  </Typography>
                  {content.map((c) => {
                    let type = c.type;
                    if (type === "text") {
                      return <Markdowner text={c.text} />;
                    }
                    if (type === "data_url") {
                      return (
                        <Box>
                          {" "}
                          <Button
                            href={c.data_url.url}
                            download
                            color="success"
                            startIcon={<Iconify icon="mdi:download" />}
                          >
                            {c.data_url.filename}
                          </Button>
                        </Box>
                      );
                    }
                  })}
                </Stack>
              </Card>
            );
          }
          if (role === "assistant") {
            let mode = this.state.conversationType;
            let isCompletion = mode === "completion";
            if (isCompletion) {
              let content = x.content;
              if (!content) {
                return null;
              }
              return (
                <AsstMessage
                  message={x}
                  threadId={this.props.id}
                  isUnAuth={true}
                />
              );
            }

            return (
              <Card
                sx={{
                  p: 1,
                  m: 1,
                  bgcolor: "background.paper",
                  borderRadius: 2,
                  boxShadow: 3,
                }}
              >
                <Stack>
                  <Typography variant="overline">Harley</Typography>
                  {content.map((c) => {
                    let type = c.type;
                    if (type === "text") {
                      if (typeof c.text === "string") {
                        return <Markdowner text={c.text} />;
                      }
                      let hasAnnotations = c.text.annotations
                        ? !!c.text.annotations.length
                        : false;
                      let annotations = [];
                      if (hasAnnotations) {
                        annotations = c.text.annotations;
                      }
                      return (
                        <Markdowner
                          text={c.text.value}
                          annotations={annotations}
                          isAsst={this.state.conversationType === "assistant"}
                        />
                      );
                    }
                    if (type === "image_file") {
                      let fileId = c.image_file.file_id;
                      let url = `/harley/GeneratedImage/${fileId}`;
                      let apiUrl = process.env.REACT_APP_API_URL;
                      let imageUrl = `${apiUrl}${url}`;
                      return (
                        <Box
                          sx={{
                            maxWidth: "90vw",
                          }}
                        >
                          <img src={imageUrl} alt="IMAGE" />
                        </Box>
                      );
                    }
                  })}
                </Stack>
              </Card>
            );
          }
        })}
      </Stack>
    );
  };
  renderSharedArea = () => {
    return (
      <Paper>
        <Stack spacing={0.5}>
          <Alert
            severity="info"
            icon={<Iconify icon="game-icons:sparkles" />}
            sx={{
              fontSize: "small",
            }}
          >
            Harley is an intelligent AI agent that can work wonders. It can
            understand documents, be a medical copilot, a patient navigator, or
            just a fun person to chat with.
            <br />
            Built by Radical Health and 🤖
          </Alert>
          <Stack direction="row" alignItems={"center"} spacing={0.5}>
            <TextField
              fullWidth
              disabled={this.state.isRegistering}
              size="small"
              label="Your Email"
              name="email"
              value={this.state.email}
              onChange={(e) => {
                this.setState({ email: e.target.value });
              }}
            />
            <LoadingButton
              disabled={!this.state.email}
              loading={this.state.isRegistering}
              onClick={this.registerInterest}
            >
              Register Interest
            </LoadingButton>
          </Stack>
        </Stack>
      </Paper>
    );
  };
  renderOverall = () => {
    return (
      <Stack
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "90dvh",
          overflow: "hidden",
          width: "100vw",
          margin: "auto",
          alignContent: "flex-end",
          paddingTop: "7px",
          paddingBottom: "7px",
        }}
      >
        <Stack
          sx={{
            p: 1,
            m: 1,
            bgcolor: "info.darker",
            borderRadius: 1,
            boxShadow: 3,
          }}
          justifyContent={"space-between"}
          alignItems={"center"}
          direction="row"
          spacing="1"
        >
          <Typography variant="subtitle2" color={"#fff"}>
            {this.state.title}
          </Typography>
          <IconButton
            onClick={() => {
              copyToClipboard(window.location.href)
                .then(() => {
                  cogoToast.success("Link copied to clipboard");
                })
                .catch((error) => {
                  cogoToast.error(
                    "Failed to copy URL. This is an iOS issue. Please share the URL directly."
                  );
                });
            }}
            sx={{
              color: "#fff",
            }}
          >
            <Iconify icon="mi:share" />
          </IconButton>
        </Stack>

        <Paper
          sx={{
            padding: 1,
            overflowY: "scroll",
          }}
        >
          {this.renderMessages()}
        </Paper>
        <Paper
          sx={{
            padding: 1,
            height: "35%",
            boxShadow: "0px -25px 20px -20px rgba(0,0,0,0.65)",
            borderTop: "1px solid #f0f0f0",
          }}
        >
          {this.renderSharedArea()}
        </Paper>
      </Stack>
    );
  };
  render() {
    if (this.state.isLoading) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100dvh",
            width: "100vw",
          }}
        >
          <LinearProgress />
        </div>
      );
    }
    if (this.state.isError) {
      return <View500 />;
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100dvh",
          overflow: "hidden",
        }}
      >
        {this.renderOverall()}
      </div>
    );
  }
}

export default WithAPICall(Thread);
